import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {StorageService} from "../../services/storage/storage.service";
import {OrgDto} from "../dto/org.dto";
import {UrlBuilder} from "../item/url.item";
import {WrapperDto} from "../dto/wrapper.dto";
import {map} from "rxjs/operators";
import {OverviewDto} from "../dto/overview-dto";
import {Observable} from "rxjs";
import {UrlDto} from "../item/url.dto";

@Injectable({providedIn: 'root'})
export class OverviewRepo {

  public static readonly REFRESH_DELAY_SEC: number = 60;

  private readonly overviewRead: string = '/v1/org/{orgId}/overview';

  private readonly overviewStorageExpire: number = OverviewRepo.REFRESH_DELAY_SEC - 5;
  private readonly overviewStorageKey: string = 'overview:';

  private readonly http: HttpClient = inject(HttpClient);
  private readonly storageService: StorageService = inject(StorageService);

  public getByOrg(org: OrgDto): Observable<WrapperDto<OverviewDto>> {
    const url: UrlDto = UrlBuilder.builder().addPath(this.overviewRead).addParam('orgId', org.id).build();
    return this.storageService.cache(this.overviewStorageKey + org.id,
      () => this.http.get<WrapperDto<OverviewDto>>(url.getUrl(), url.getOptions()),
      this.overviewStorageExpire
    ).pipe(map((res) => new WrapperDto(res)));
  }
}
